import debug from 'bows';
import Dropdown from './_dropdown';

const log = debug('primary-nav');

export default class {
	/**
	 * Menu constructor
	 */
	constructor( node, opts = {} ) {
		this.opts = Object.assign( {
			openClass: 'nav__menu-item--open',
			parents  : '.nav__menu-item--has-children',
			delay: 100,
			children: '.nav__menu',
			togglers: '.nav__menu-toggle',
		}, opts );

		this.node  = (typeof node === 'string') ? document.querySelector(node) : node;

		if ( ! this.node ) {
			log('node missing, abort!');
			return;
		}

		this.parents = Array.from( this.node.querySelectorAll( this.opts.parents ) );
		this.parents.forEach( (parent) => {
			parent.addEventListener('dropdown.open', () => {
				this.dropdowns.forEach( (drop) => {
					log('dropdown.open', drop.node, parent, drop.node !== parent );
					if ( drop.opened && drop.node !== parent ) {
						drop.close();
					}
				} );
			});
		});

		this.dropdowns = this.parents.map( ( parent ) => new Dropdown( parent, {
			class: this.opts.openClass,
			delay: this.opts.delay
		} ) );

		this.mobileTogglers = this.parents.map( ( parent ) => parent.querySelector( this.opts.togglers ) );

		this.mobileTogglers.forEach( ( toggler, index ) => {
			if ( toggler ) {
				toggler.addEventListener( 'click', () => {
					let parent = this.parents[ index ];

					if ( parent.classList.contains( this.opts.openClass ) ) {
						toggler.innerHTML = '+';
						parent.classList.remove( this.opts.openClass );
					} else {
						toggler.innerHTML = '―'; // this is a dash, not a minus sign
						parent.classList.add( this.opts.openClass );
					}
				} );
			}
		} );

		log(this);
	}
}
